import { useEffect } from 'react';
import useTitle from '../hooks/useTitle';
import Button from '../components/Button';

/** Shared layout for the privacy policy and terms pages. */
export default function Legal({ doc }) {
  useTitle(`${doc.title} — ISL Tech`);
  useEffect(() => { window.scrollTo(0, 0); }, [doc]);

  return (
    <article className="container-site py-sec-y">
      <div className="grid gap-x-10 gap-y-8 nav:grid-cols-[minmax(0,4fr)_minmax(0,8fr)]">
        <div>
          <div className="eyebrow text-accent-700">Legal</div>
          <h1 className="mt-4 text-[clamp(36px,4.4vw,60px)] leading-[0.95] tracking-[-0.04em]">{doc.title}</h1>
          <p className="mt-4 text-[13px] font-semibold uppercase tracking-[0.08em] text-neutral-700">Updated {doc.updated}</p>
          <Button href="#contact" variant="ink" size={52} spread className="mt-8">Contact us</Button>
        </div>
        <div className="border-t-2 border-ink">
          <p className="pretty py-6 text-lead">{doc.intro}</p>
          {doc.sections.map(s => (
            <section key={s.h} className="border-t-1 border-divider py-6">
              <h2 className="text-[clamp(20px,1.8vw,26px)] leading-[1.1] tracking-[-0.02em]">{s.h}</h2>
              {s.p.map(p => <p key={p} className="pretty mt-3 text-body text-neutral-800">{p}</p>)}
            </section>
          ))}
        </div>
      </div>
    </article>
  );
}
